import { useTranslation } from "react-i18next";
import { Inbox } from "lucide-react";
import type { UnsortedPaneHeaderProps } from "./types";

export const UnsortedPaneHeader = ({ planCount }: UnsortedPaneHeaderProps) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-shrink-0 items-center gap-2.5 border-b border-gray-200 px-4 py-3">
      <span className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-lg border border-dashed border-gray-300 bg-gray-50 text-gray-500">
        <Inbox size={16} />
      </span>
      <div className="min-w-0 flex-1">
        <div className="flex items-center gap-2">
          <span className="text-base font-semibold text-gray-700">
            {t("smartSurveyor.folders.suggestion.unsorted")}
          </span>
          <span className="whitespace-nowrap rounded border border-gray-200 bg-white px-2 py-px text-xs font-medium text-gray-600">
            {t("smartSurveyor.folders.suggestion.planCount", {
              count: planCount,
            })}
          </span>
        </div>
        <p className="mt-0.5 text-sm text-gray-500">
          {t("smartSurveyor.folders.suggestion.unsortedHint")}
        </p>
      </div>
    </div>
  );
};
